"use strict";
document.addEventListener("DOMContentLoaded", init);

function init() {
  changeDisabled();
  modal();
  accordion();
  valiantImageSlider();
  valiantImageSwitch();
  productImageSlider();
}


function changeDisabled() {
  const clothPropertyName = "properties[Eyeglass Cloth]";
  const selectCloth = [...document.querySelectorAll("select")].find(
    (el) => el.getAttribute("name") === clothPropertyName,
  );
  if (!selectCloth) {
    return;
  }
  const cartButton = document.querySelector(".product-form__submit");
  const variantInputs = document.querySelectorAll('form input[name="id"]');
  function clothRequiresSelection() {
    return selectCloth.value === "";
  }
  function changeHandler() {
    if (!cartButton) {
      return;
    }
    cartButton.disabled = clothRequiresSelection();
  }
  changeHandler();
  selectCloth.addEventListener("change", changeHandler);
  variantInputs.forEach((input) => {
    input.addEventListener("change", () => {
      changeHandler();
      setTimeout(changeHandler, 850);
    });
  });

  // バリアント変更後にテーマ側がカートボタンの disabled を外すことがある。メガネ拭き未選択のときは
  // disabled 属性の変化を監視し、必須なのに有効になっていたら再度無効にする。
  function restoreClothEnforceDisabled() {
    if (!cartButton) {
      return;
    }
    if (clothRequiresSelection() && !cartButton.disabled) {
      cartButton.disabled = true;
    }
  }
  if (cartButton) {
    const clothButtonObserver = new MutationObserver(restoreClothEnforceDisabled);
    clothButtonObserver.observe(cartButton, {
      attributes: true,
      attributeFilter: ["disabled"],
    });
  }
}


function modal() {
  const modal = document.getElementById("modal");
  const open = document.getElementById("modal-open");
  const close = document.getElementById("modal-close");
  if (modal) {
    open.addEventListener("click", function () {
      modal.classList.add("is-active");
      document.documentElement.classList.add("is-fixed");
    });
    close.addEventListener("click", function () {
      document.documentElement.classList.remove("is-fixed");
      modal.classList.remove("is-active");
    });
    modal.addEventListener("click", function () {
      document.documentElement.classList.remove("is-fixed");
      modal.classList.remove("is-active");
    });
  }
}

function accordion() {
  const elems = document.querySelectorAll('[id^="Details-"]');
  elems.forEach((elem) => {
    elem.addEventListener("click", (e) => {
      if (e.target.tagName == "A") {
        return;
      } else {
        elem.classList.toggle("is-open");
        slideToggle(elem.querySelector(".accordion__content"), 300);
      }
    });
  });
}

function valiantImageSlider() {
  document.querySelectorAll(".swiper.valiant-slider").forEach((root) => {
    const isClipOnGallery = root.classList.contains("valiant-slider--clip-on");
    new Swiper(root, {
      speed: 1000,
      centeredSlides: true,
      loop: !isClipOnGallery,
      navigation: {
        nextEl: root.querySelector(".swiper-button-next"),
        prevEl: root.querySelector(".swiper-button-prev"),
      },
      slidesPerView: 1.22,
      spaceBetween: 10,
      breakpoints: {
        750: {
          slidesPerView: 2.5,
          spaceBetween: 15,
        },
      },
    });
  });
}

function valiantImageSwitch() {
  const isClipOnMode = document.querySelector("[data-clip-on-mode='true']") !== null;
  const elements = document.querySelectorAll(".product-form__input input");
  const buttons = document.querySelectorAll(".product-form__input label");
  const colorSelect = document.querySelector(".clip-on-color-select");
  const mainContent = document.getElementById("MainContent");
  const accordions = document.querySelectorAll(".product__accordion");
  const cartButton = document.querySelector(".product-form__submit");
  const faqButton = document.getElementById("faqButton");
  const modalButton = document.getElementById("modal-open");
  const toggleButton = document.querySelector(".product-form__input input[type='radio'] + label");
  const colorLendsText = document.querySelector(".product__subtitle span");
  let pageColors = null;
  let backgroundColor = "";
  let elementsColor = "";
  let cullentValue = "";

  elements.forEach((element) => {
    if (element.checked) {
      cullentValue = element.value;
    }
  });
  if (!cullentValue && colorSelect) {
    cullentValue = colorSelect.value;
  }

  function getColors() {
    if (!document.querySelector(".color-settings")) return;
    const settings = document.querySelector(".color-settings");
    const jsonText = settings.textContent;
    const jsonTextParse = JSON.parse(jsonText);
    backgroundColor = jsonTextParse[0];
    elementsColor = jsonTextParse[1];
  }

  function getMultiColors(cullentValue) {
    if (!pageColors) {
      const settings = document.querySelector(".color-settings");
      if (!settings) return;

      const jsonText = settings.textContent;
      pageColors = JSON.parse(jsonText);
    }

    return pageColors[cullentValue];
  }

  function setCurrentMedia(cullentValue) {
    const activeSlider = document.querySelector(`[data-variants-value="${cullentValue}"]`);
    if (!activeSlider) return;
    document.querySelectorAll("[data-variants-value]").forEach((element) => {
      element.classList.remove("is-active");
    });
    activeSlider.classList.add("is-active");

    const clipSwiperRoot = activeSlider.closest(".valiant-slider--clip-on");
    if (clipSwiperRoot && clipSwiperRoot.swiper) {
      const slides = [...clipSwiperRoot.querySelectorAll(".swiper-slide")];
      const slideIndex = slides.indexOf(activeSlider);
      if (slideIndex >= 0) {
        clipSwiperRoot.swiper.slideTo(slideIndex);
      }
    }
  }

  function setColors(cullentValue) {
    if (!mainContent || !cartButton) return;
    if (cullentValue == "Clear Lens") {
      mainContent.classList.remove("is-active");
      mainContent.style.background = "";
      if (faqButton) faqButton.style = "";
      cartButton.style.backgroundColor = "";
      cartButton.style.color = "";
      if (toggleButton) toggleButton.style.background = "";
      if (modalButton) modalButton.style = "";
      accordions.forEach((accordion) => {
        accordion.style.borderBottomColor = "";
      });
    } else {
      mainContent.classList.add("is-active");
      mainContent.style.background = backgroundColor;
      if (faqButton) faqButton.style.background = elementsColor;
      if (toggleButton) toggleButton.style.background = elementsColor;
      if (modalButton) modalButton.style.backgroundColor = elementsColor;
      accordions.forEach((accordion) => {
        accordion.style.borderBottomColor = elementsColor;
      });
      if (backgroundColor == "#000000") {
        if (faqButton) faqButton.style.color = "#fff";
        cartButton.style.color = "#fff";
        cartButton.style.backgroundColor = elementsColor;
      } else {
        cartButton.style.color = backgroundColor;
      }
    }
  }

  function setMultiColors(cullentValue) {
    const colors = getMultiColors(cullentValue);
    if (!colors || !mainContent || !cartButton) return;

    mainContent.classList.remove("is-active");
    if (colors[0] && colors[0] != "#ffffff" && colors[0] != "#fff") {
      mainContent.classList.add("is-active");
    }

    mainContent.style.background = colors[0];
    if (faqButton) {
      faqButton.style.color = "#fff";
      faqButton.style.background = colors[1];
    }
    if (modalButton) {
      modalButton.style.color = "#fff";
      modalButton.style.backgroundColor = colors[1];
    }
    accordions.forEach((accordion) => {
      accordion.style.borderBottomColor = colors[1];
    });
    if (colors[0] == "#000000") {
      cartButton.style.color = "#fff";
      if (colors[1] == "#000000") {
        cartButton.style.backgroundColor = "#515151";
      } else {
        cartButton.style.backgroundColor = colors[1];
      }
    } else {
      if (colors[1] == "#000000") {
        cartButton.style.color = "#fff";
      } else {
        cartButton.style.color = colors[1];
      }
    }
    if (colorLendsText) {
      colorLendsText.innerHTML = cullentValue;
    }
  }

  setCurrentMedia(cullentValue);
  if (!isClipOnMode) {
    setMultiColors(cullentValue);
  }

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      buttons.forEach((btn) => {
        btn.classList.remove("is-active");
      });
      button.classList.add("is-active");
      cullentValue = button.previousElementSibling.value;
      setCurrentMedia(cullentValue);
      if (!isClipOnMode) {
        setMultiColors(cullentValue);
      }
    });
  });

  if (colorSelect) {
    colorSelect.addEventListener("change", () => {
      cullentValue = colorSelect.value;
      setCurrentMedia(cullentValue);
      if (!isClipOnMode) {
        setMultiColors(cullentValue);
      }
    });
  }
}

function productImageSlider() {
  let productImageSwiper = new Swiper(".swiper.product-slider", {
    speed: 1000,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    slidesPerView: 1,
  });
}
